import {AfterViewInit, Component, ElementRef, OnInit} from '@angular/core';
import {DocumentFileService} from "../../../service/document-file.service";
import {DownloadService} from "../../../service/download.service";
import {BatchDownload} from "../../../model/batchDownload";

@Component({
  selector: 'app-download-list',
  templateUrl: './download-list.component.html',
  styleUrls: ['./download-list.component.css']
})
export class DownloadListComponent implements OnInit, AfterViewInit {

  batchDownloads : BatchDownload[] = [];

  constructor(private downloadService: DownloadService, private elementRef: ElementRef) { }

  ngOnInit(): void {
    this.downloadService.getAllBatchDownloadsForUser().subscribe(res => {
      this.batchDownloads = res;
      this.sortBatchDownloadEntryDates();
    },error => {
      console.log(error)
    })
  }

  ngAfterViewInit() {
    this.elementRef.nativeElement.ownerDocument
      .body.style.backgroundColor = '#f7f7f7';
  }

  sortBatchDownloadEntryDates() {
    this.batchDownloads.sort((a, b) => new Date(b.requestDate).getTime() - new Date(a.requestDate).getTime())
  }

}
